const atomic = require('../../../git_modules/@tomandco/atomic/config/typography');

/**
 * Font families used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .font-1 { font-family: "'Lato', sans-serif"; }
 * ```
 */
const fontFamily = [
    // default atomic
    ...atomic.fontFamily,
    // custom local
    { key: '1', value: "'Gotham', sans-serif", title: 'Gotham' }
];
exports.fontFamily = fontFamily;

const fontWeight = [
    // default atomic
    // ...atomic.fontWeight,
    // custom local
    { key: 'regular', value: '400', title: 'Regular' },
    { key: 'medium', value: '500', title: 'Medium' },
    { key: 'bold', value: '700', title: 'Bold' }
];
exports.fontWeight = fontWeight;

const textStyle = [
    { key: 'xl-hero', title: 'XL Hero' },
    { key: 'hero', title: 'Hero' },
    { key: 'h1', title: 'Heading 1' },
    { key: 'h2', title: 'Heading 2' },
    { key: 'h3', title: 'Heading 3' },
    { key: 'h4', title: 'Heading 4' },
    { key: 's1', title: 'Sub-heading 1' },
    { key: 's2', title: 'Sub-heading 2' },
    { key: 's3', title: 'Sub-heading 3' },
    { key: 's4', title: 'Sub-heading 4' },
    { key: 'p1', title: 'Paragraph 1' },
    { key: 'p2', title: 'Paragraph 2' },
    { key: 'p3', title: 'Paragraph 3' },
    { key: 'p4', title: 'Paragraph 4' },
    { key: 'c1', title: 'Caption 1' },
    { key: 'o1', title: 'Overline 1' },
    { key: 'q1', title: 'Quote 1' }
];
exports.textStyle = textStyle;
